/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} No_Scene_Description_Jobs_FoundInputs */



/**
* | output |
* | --- |
* | "No shot description jobs found for the selected period." |
*
* @param {No_Scene_Description_Jobs_FoundInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const no_scene_description_jobs_found = /** @type {((inputs?: No_Scene_Description_Jobs_FoundInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<No_Scene_Description_Jobs_FoundInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun poste de description de prise de vue n'a été trouvé pour la période sélectionnée.")
	if (locale === "de") return /** @type {LocalizedString} */ ("Für den ausgewählten Zeitraum wurden keine Stellenangebote mit Aufnahmebeschreibung gefunden.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Non sono state trovate descrizioni di lavori per il periodo selezionato.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("За выбранный период не найдено заданий по описанию кадров.")
	if (locale === "es") return /** @type {LocalizedString} */ ("No se encontraron descripciones de trabajos de toma para el período seleccionado.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("所选时间段内未找到镜头描述工作。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("選択した期間に該当する撮影説明の求人は見つかりませんでした。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("चयनित अवधि के लिए कोई शॉट विवरण वाली नौकरियां नहीं मिलीं।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Não foram encontradas vagas de descrição de cenas para o período selecionado.")
	return /** @type {LocalizedString} */ ("No shot description jobs found for the selected period.")
});